import styled from '@emotion/styled';
import { setMargin } from '../../helpers';

export const CategoriesWrapper = styled.div`
  ${setMargin};
  display: flex;
  flex-direction: column;
`;
